<template>
    <div>
        <form @submit.prevent="formSubmit" id="formGen">
            <div v-if="field && modelData" v-for="field in fields" :key="field.name" class="form-group">
                <label :for="field.name">{{field.displayName}}</label>
                <template v-if="field.formType == 'text'">
                    <input v-model="modelData[field.name]" type="text" class="form-control" :id="field.name" :placeholder="field.placeHolder" v-bind:readonly="field.readOnly">
                </template>
                <template v-if="field.formType == 'textArea'">
                    <textarea v-model="modelData[field.name]" type="text" class="form-control" :id="field.name" :placeholder="field.placeHolder"></textarea>
                </template>
                <template v-if="field.formType == 'phone'">
                    <input v-model="modelData[field.name]" type="text" class="form-control" :id="field.name" :placeholder="field.placeHolder">
                    <span style="color:red;">{{phoneError}}</span>
                </template>
                <template v-if="field.formType == 'email'">
                    <input v-model="modelData[field.name]" type="email" class="form-control" :id="field.name">
                </template>
                <template v-if="field.formType == 'password'">
                    <input v-model="modelData[field.name]" type="password" class="form-control" :id="field.name">
                </template>
                <template v-if="field.formType == 'select' && field.options != null">
                    <select v-model="modelData[field.name]" class="form-control" :id="field.name">
                        <option v-for="option in field.options" :key="option.value" :value="option.value">{{option.name}}</option>
                    </select>
                </template>
                <template v-if="field.formType == 'multiselect' && field.options != null">
                    <multiselect v-model="modelData[field.name]" :options="field.options" :optionsLimit="2000" :multiple="true" :close-on-select="false" label="name" track-by="id"></multiselect>
                </template>
                <small v-if="field.isRequired" class="form-text text-muted">Required</small>
            </div>
            <div>
                <input type="submit" value="Submit" id="formGenButton"/>
            </div>
        </form>
    </div>
</template>
<script>
    import Multiselect from 'vue-multiselect'

    export default {
        data: function () {
            return {
                phoneError: '',
            }
        },
        props: {
            modelData: Object,
            fields: {
                type: Array,
                required: true,
                name: {
                    type: String,
                    required: true
                },
                displayName: {
                    type: String
                },
                formType: {
                    type: String,
                    required: true
                },
                isRequired: {
                    type: Boolean
                },
                options: {
                    type: Array,
                    name: {
                        type: String
                    },
                    id: {
                        type: String
                    }
                },
                nameField: {
                    type: String
                },
                idField: {
                    type: String
                },
                readOnly: {
                    type: Boolean
                },
                placeHolder: {
                    type: String
                }
            }
        },
        methods: {
            formSubmit() {
                this.phoneError = ''
                for (var i = 0; i < this.fields.length; i++) {
                    if (this.fields[i].formType == 'phone') {
                        if (this.modelData[this.fields[i].name] && !this.validPhone(this.modelData[this.fields[i].name])) {
                            this.phoneError = 'Phone number format must be in ########## or ###-###-#### format'
                            return;
                        }
                    }
                }
                document.getElementById("formGenButton").disabled = true
                this.$events.fire('form-submit', this.modelData)
            },
            validPhone(phoneNumber) {
                var re = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/
                return re.test(phoneNumber)
            },
        },
        components: { Multiselect }
    }
</script>
<style src="@/styles/multiselect.scss"></style>